module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ujB77"))).then(() => parcelRequire('hEqeo'));